// extracted by mini-css-extract-plugin
export default {"container":"borderWrapper_container__L1SYU","title":"borderWrapper_title__l52VN","closeButton":"borderWrapper_closeButton__FNZKp"};